// Clients
export const FETCH_CLIENTS_START = 'FETCH_CLIENTS_START'
export const FETCH_CLIENTS_SUCCESS = 'FETCH_CLIENTS_SUCCESS'
export const FETCH_CLIENTS_FAIL = 'FETCH_CLIENTS_FAIL'
export const FETCH_CATEGORY_START = 'FETCH_CATEGORY_START'
export const FETCH_CATEGORY_SUCCESS = 'FETCH_CATEGORY_SUCCESS'
export const FETCH_CATEGORY_FAIL = 'FETCH_CATEGORY_FAIL'
export const DELETE_CLIENT = 'DELETE_CLIENT'
export const CLOSE_MODAL = 'CLOSE_MODAL'
export const REAL_CLIENT_DELETE_START = 'REAL_CLIENT_DELETE_START'
export const REAL_CLIENT_DELETE_FAIL = 'REAL_CLIENT_DELETE_FAIL'
export const REAL_CLIENT_DELETE_SUCCESS = 'REAL_CLIENT_DELETE_SUCCESS'
export const DELETE_CLIENT_FINISHED = 'DELETE_CLIENT_FINISHED'
export const CLIENT_SEARCH_CHANGE = 'CLIENT_SEARCH_CHANGE'
export const DISEASE_CODE_SEARCH_CHANGE = 'DISEASE_CODE_SEARCH_CHANGE'
export const SHOW_ALL_CLIENTS = 'SHOW_ALL_CLIENTS'
export const SEE_REQUEST = 'SEE_REQUEST'
export const SORT_CLIENTS = 'SORT_CLIENTS'
export const ADD_CATEGORY = 'ADD_CATEGORY'
export const CANCEL_ADD_CATEGORY = 'CANCEL_ADD_CATEGORY'
export const CANCEL_DELETE_CATEGORY = 'CANCEL_DELETE_CATEGORY'
export const ADD_CATEGORY_CHANGE = 'ADD_CATEGORY_CHANGE'
export const REAL_ADD_CATEGORY_START = 'REAL_ADD_CATEGORY_START'
export const REAL_ADD_CATEGORY_FAIL = 'REAL_ADD_CATEGORY_FAIL'
export const REAL_ADD_CATEGORY_SUCCESS = 'REAL_ADD_CATEGORY_SUCCESS'
export const REAL_DELETE_CATEGORY_START = 'REAL_DELETE_CATEGORY_START'
export const REAL_DELETE_DISEASE_CATEGORY_START = 'REAL_DELETE_DISEASE_CATEGORY_START'
export const REAL_DELETE_OPERATION_CATEGORY_START = 'REAL_DELETE_OPERATION_CATEGORY_START'
export const REAL_DELETE_SECOND_CATEGORY_START = 'REAL_DELETE_SECOND_CATEGORY_START'
export const REAL_DELETE_CATEGORY_FAIL = 'REAL_DELETE_CATEGORY_FAIL'
export const REAL_DELETE_DISEASE_CATEGORY_FAIL = 'REAL_DELETE_DISEASE_CATEGORY_FAIL'
export const REAL_DELETE_OPERATION_CATEGORY_FAIL = 'REAL_DELETE_OPERATION_CATEGORY_FAIL'
export const REAL_DELETE_SECOND_CATEGORY_FAIL = 'REAL_DELETE_SECOND_CATEGORY_FAIL'
export const REAL_DELETE_CATEGORY_SUCCESS = 'REAL_DELETE_CATEGORY_SUCCESS'
export const CHOOSE_CATEGORY = 'CHOOSE_CATEGORY'
export const CHOOSE_SECOND_CATEGORY = 'CHOOSE_SECOND_CATEGORY'
export const ADD_EMPTY_CATEGORY = 'ADD_EMPTY_CATEGORY'
export const ADD_DOLLAR_CATEGORY = 'ADD_DOLLAR_CATEGORY'
export const ADD_CLIENT_TO_CATEGORY = 'ADD_CLIENT_TO_CATEGORY'
export const ADD_TEMPLATE_TO_CATEGORY = 'ADD_TEMPLATE_TO_CATEGORY'
export const CLICK_CATEGORY = 'CLICK_CATEGORY'
export const CLICK_CHILD_DOCTOR = 'CLICK_CHILD_DOCTOR'
export const CHECK_DISEASE_CATEGORY = 'CHECK_DISEASE_CATEGORY'
export const REAL_ADD_CLIENT_TO_CATEGORY_START = 'REAL_ADD_CLIENT_TO_CATEGORY_START'
export const REAL_ADD_CLIENT_TO_CATEGORY_FAIL = 'REAL_ADD_CLIENT_TO_CATEGORY_FAIL'
export const REAL_ADD_CLIENT_TO_CATEGORY_SUCCESS = 'REAL_ADD_CLIENT_TO_CATEGORY_SUCCESS'
export const SEARCH_DISEASE_CATEGORY_START = 'SEARCH_DISEASE_CATEGORY_START'
export const SEARCH_DISEASE_CATEGORY_FAIL = 'SEARCH_DISEASE_CATEGORY_FAIL'
export const SEARCH_DISEASE_CATEGORY_SUCCESS = 'SEARCH_DISEASE_CATEGORY_SUCCESS'
export const ADD_CLIENT_TO_EMPTY_CATEGORY = 'ADD_CLIENT_TO_EMPTY_CATEGORY'
export const DELETE_CATEGORY = 'DELETE_CATEGORY'
export const DELETE_DISEASE_CATEGORY = 'DELETE_DISEASE_CATEGORY'
export const DELETE_SECOND_CATEGORY = 'DELETE_SECOND_CATEGORY'
export const DELETE_OPERATION_CATEGORY = 'DELETE_OPERATION_CATEGORY'
export const DELETE_ONE_CATEGORY = 'DELETE_ONE_CATEGORY'
export const DELETE_ONE_DISEASE_CATEGORY = 'DELETE_ONE_DISEASE_CATEGORY'
export const ADD_DISEASE_CATEGORY = 'ADD_DISEASE_CATEGORY'
export const ADD_OPERATION_CATEGORY = 'ADD_OPERATION_CATEGORY'
export const DELETE_ONE_OPERATION_CATEGORY = 'DELETE_ONE_OPERATION_CATEGORY'
export const DELETE_ONE_SECOND_CATEGORY = 'DELETE_ONE_SECOND_CATEGORY'
export const COLLAPSE = 'COLLAPSE'
export const CHOOSE_CHILD_DOCTOR_CATEGORY = 'CHOOSE_CHILD_DOCTOR_CATEGORY'
export const ADD_CHILD_CATEGORY = 'ADD_CHILD_CATEGORY'
export const DELETE_CHILD_CATEGORY = 'DELETE_CHILD_CATEGORY'
export const CANCEL_ADD_CHILD_CATEGORY = 'CANCEL_ADD_CHILD_CATEGORY'
export const ADD_EMPTY_CHILD_CATEGORY = 'ADD_EMPTY_CHILD_CATEGORY'
export const ADD_DOLLAR_CHILD_CATEGORY = 'ADD_DOLLAR_CHILD_CATEGORY'
export const REAL_ADD_CHILD_CATEGORY_START = 'REAL_ADD_CHILD_CATEGORY_START'
export const REAL_ADD_CHILD_CATEGORY_FAIL = 'REAL_ADD_CHILD_CATEGORY_FAIL'
export const REAL_ADD_REST_CATEGORY_FAIL = 'REAL_ADD_REST_CATEGORY_FAIL'
export const SPECIALIZE_START = 'SPECIALIZE_START'
export const SPECIALIZE_SUCCESS = 'SPECIALIZE_SUCCESS'
export const SPECIALIZE_FAIL = 'SPECIALIZE_FAIL'
export const SEE_QR_CODE_FAIL = 'SEE_QR_CODE_FAIL'
export const SEE_QR_CODE_SUCCESS = 'SEE_QR_CODE_SUCCESS'

// Templates
export const FETCH_TEMPLATES_START = 'FETCH_TEMPLATES_START'
export const FETCH_TEMPLATES_SUCCESS = 'FETCH_TEMPLATES_SUCCESS'
export const FETCH_TEMPLATES_FAIL = 'FETCH_TEMPLATES_FAIL'
export const FETCH_EXPERT_TEMPLATES_START = 'FETCH_EXPERT_TEMPLATES_START'
export const FETCH_EXPERT_TEMPLATES_SUCCESS = 'FETCH_EXPERT_TEMPLATES_SUCCESS'
export const FETCH_EXPERT_TEMPLATES_FAIL = 'FETCH_EXPERT_TEMPLATES_FAIL'
export const FETCH_TEAM_TEMPLATES_START = 'FETCH_TEAM_TEMPLATES_START'
export const FETCH_TEAM_TEMPLATES_SUCCESS = 'FETCH_TEAM_TEMPLATES_SUCCESS'
export const FETCH_TEAM_TEMPLATES_FAIL = 'FETCH_TEAM_TEMPLATES_FAIL'
export const FETCH_TEAMS_AND_FIRST_START = 'FETCH_TEAMS_AND_FIRST_START'
export const FETCH_TEAMS_AND_FIRST_SUCCESS = 'FETCH_TEAMS_AND_FIRST_SUCCESS'
export const FETCH_TEAMS_AND_FIRST_FAIL = 'FETCH_TEAMS_AND_FIRST_FAIL'
export const DOWNLOAD_TEMPLATE_START = 'DOWNLOAD_TEMPLATE_START'
export const DOWNLOAD_TEMPLATE_SUCCESS = 'DOWNLOAD_TEMPLATE_SUCCESS'
export const DOWNLOAD_TEMPLATE_FAIL = 'DOWNLOAD_TEMPLATE_FAIL'
export const SEE_TEAM_MEMBERS_START = 'SEE_TEAM_MEMBERS_START'
export const SEE_TEAM_MEMBERS_SUCCESS = 'SEE_TEAM_MEMBERS_SUCCESS'
export const SEE_TEAM_MEMBERS_FAIL= 'SEE_TEAM_MEMBERS_FAIL'
export const ADD_EXPERT = 'ADD_EXPERT'
export const ADD_EXPERT_OR_TEAM = 'ADD_EXPERT_OR_TEAM'
export const ADD_EXPERT_START = 'ADD_EXPERT_START'
export const ADD_EXPERT_SUCCESS = 'ADD_EXPERT_SUCCESS'
export const ADD_EXPERT_FAIL = 'ADD_EXPERT_FAIL'
export const ADD_TEAM_START = 'ADD_TEAM_START'
export const ADD_TEAM_SUCCESS = 'ADD_TEAM_SUCCESS'
export const ADD_TEAM_FAIL = 'ADD_TEAM_FAIL'
export const REAL_DELETE_TEAM_MEMBER_START = 'REAL_DELETE_TEAM_MEMBER_START'
export const REAL_DELETE_TEAM_MEMBER_SUCCESS = 'REAL_DELETE_TEAM_MEMBER_SUCCESS'
export const REAL_DELETE_TEAM_MEMBER_FAIL = 'REAL_DELETE_TEAM_MEMBER_FAIL'
export const REAL_LEAVE_TEAM_START = 'REAL_LEAVE_TEAM_START'
export const REAL_LEAVE_TEAM_SUCCESS = 'REAL_LEAVE_TEAM_SUCCESS'
export const REAL_LEAVE_TEAM_FAIL = 'REAL_LEAVE_TEAM_FAIL'
export const REAL_DELETE_TEAM_START = 'REAL_DELETE_TEAM_START'
export const REAL_DELETE_TEAM_SUCCESS = 'REAL_DELETE_TEAM_SUCCESS'
export const REAL_DELETE_TEAM_FAIL = 'REAL_DELETE_TEAM_FAIL'
export const DELETE_TEAM_MEMBER = 'DELETE_TEAM_MEMBER'
export const LEAVE_TEAM = 'LEAVE_TEAM'
export const DELETE_TEAM = 'DELETE_TEAM'
export const TEAM_CHANGE_SUCCESS = 'TEAM_CHANGE_SUCCESS'
export const SEND_TEMPLATE = 'SEND_TEMPLATE'
export const FETCH_DOCTORS_START = 'FETCH_DOCTORS_START'
export const FETCH_DOCTORS_SUCCESS = 'FETCH_DOCTORS_SUCCESS'
export const FETCH_DOCTORS_FAIL = 'FETCH_DOCTORS_FAIL'
export const REAL_SEND_TEMPLATE_START = 'REAL_SEND_TEMPLATE_START'
export const REAL_SEND_TEMPLATE_SUCCESS = 'REAL_SEND_TEMPLATE_SUCCESS'
export const REAL_SEND_TEMPLATE_FAIL = 'REAL_SEND_TEMPLATE_FAIL'
export const CHANGE_DOCTOR = 'CHANGE_DOCTOR'
export const CHANGE_LABEL = 'CHANGE_LABEL'
export const DELETE_TEMPLATE = 'DELETE_TEMPLATE'
export const CREATE_QR_CODE_START = 'CREATE_QR_CODE_START'
export const NO_PRICE_FOUND = 'NO_PRICE_FOUND'
export const NO_PERIOD_DAY = 'NO_PERIOD_DAY'
export const CREATE_QR_CODE_SUCCESS = 'CREATE_QR_CODE_SUCCESS'
export const CREATE_QR_CODE_FAIL = 'CREATE_QR_CODE_FAIL'
export const REAL_TEMPLATE_DELETE_START = 'REAL_TEMPLATE_DELETE_START'
export const REAL_TEMPLATE_DELETE_FAIL = 'REAL_TEMPLATE_DELETE_FAIL'
export const REAL_TEMPLATE_DELETE_SUCCESS = 'REAL_TEMPLATE_DELETE_SUCCESS'
export const DELETE_TEMPLATE_FINISHED = 'DELETE_TEMPLATE_FINISHED'
export const EDIT_TEMPLATE_START = 'EDIT_TEMPLATE_START'
export const EDIT_TEMPLATE_FAIL = 'EDIT_TEMPLATE_FAIL'
export const EDIT_TEMPLATE_SUCCESS = 'EDIT_TEMPLATE_SUCCESS'
export const CREATE_PLAN_BY_TEMPLATE_START = 'CREATE_PLAN_BY_TEMPLATE_START'
export const CREATE_PLAN_BY_RECOMMEND_TEMPLATE_START = 'CREATE_PLAN_BY_RECOMMEND_TEMPLATE_START'
export const CREATE_PLAN_BY_TEMPLATE_SUCCESS = 'CREATE_PLAN_BY_TEMPLATE_SUCCESS'
export const CREATE_PLAN_BY_TEMPLATE_FAIL = 'CREATE_PLAN_BY_TEMPLATE_FAIL'
export const SEARCH_TEMPLATE_CHANGE = 'SEARCH_TEMPLATE_CHANGE'
export const SEARCH_EXPERT_TEMPLATE_CHANGE = 'SEARCH_EXPERT_TEMPLATE_CHANGE'
export const SEARCH_TEAM_TEMPLATE_CHANGE = 'SEARCH_TEAM_TEMPLATE_CHANGE'
export const SWITCH_TEMPLATE_FOCUS_TO_MY = 'SWITCH_TEMPLATE_FOCUS_TO_MY'
export const SEARCH_DOCTORS = 'SEARCH_DOCTORS'
export const SHOW_ALL_TEMPLATES = 'SHOW_ALL_TEMPLATES'
export const CHANGE_CONTENT = 'CHANGE_CONTENT'
export const SYNC_CIRCLE_SUCCESS = 'SYNC_CIRCLE_SUCCESS'
export const GET_CIRCLE_SUCCESS = 'GET_CIRCLE_SUCCESS'
export const SYNC_CIRCLE_FAIL = 'SYNC_CIRCLE_FAIL'
export const GET_CIRCLE_FAIL = 'GET_CIRCLE_FAIL'
export const ADD_TEMPLATE_TO_CIRCLE = 'ADD_TEMPLATE_TO_CIRCLE'
export const CHANGE_CIRCLE = 'CHANGE_CIRCLE'
export const REAL_ADD_TEMPLATE_TO_CIRCLE_START = 'REAL_ADD_TEMPLATE_TO_CIRCLE_START'
export const REAL_ADD_TEMPLATE_TO_CIRCLE_SUCCESS = 'REAL_ADD_TEMPLATE_TO_CIRCLE_SUCCESS'
export const REAL_ADD_TEMPLATE_TO_CIRCLE_FAIL = 'REAL_ADD_TEMPLATE_TO_CIRCLE_FAIL'
export const CHANGE_PRICE_BEFORE_QR = 'CHANGE_PRICE_BEFORE_QR'

// Add Client
export const SEARCH_NEW_CLIENT_INPUT_CHANGE = 'SEARCH_NEW_CLIENT_INPUT_CHANGE'
export const SEARCH_OR_ADD_START = 'SEARCH_OR_ADD_START'
export const FIND_ONE_CLIENT = 'FIND_ONE_CLIENT'
export const FIND_NO_ONE = 'FIND_NO_ONE'
export const SEARCH_OR_ADD_FAIL = 'SEARCH_OR_ADD_FAIL'
export const ADD_NEW_CLIENT_SUCCESS = 'ADD_NEW_CLIENT_SUCCESS'
export const ALREADY_A_CLIENT = 'ALREADY_A_CLIENT'
export const ADD_CLIENT_INIT = 'ADD_CLIENT_INIT'


// Exercise
export const PLAY_VIDEO = 'PLAY_VIDEO'
export const CLOSE_VIDEO = 'CLOSE_VIDEO'
export const CLOSE_MESSAGE = 'CLOSE_MESSAGE'
export const EXERCISE_INIT = 'EXERCISE_INIT'
export const EXERCISE_INIT_DONE = 'EXERCISE_INIT_DONE'
export const NAME_CHANGE = 'NAME_CHANGE'
export const CLIENT_NAME_B_CHANGE = 'CLIENT_NAME_B_CHANGE'
export const CLIENT_EMAIL_CHANGE = 'CLIENT_EMAIL_CHANGE'
export const INTRODUCTION_CHANGE = 'INTRODUCTION_CHANGE'
export const CLIENT_CHANGE = 'CLIENT_CHANGE'
export const TITLE_CHANGE_STUDENT = 'TITLE_CHANGE_STUDENT'
export const ADD_MOVEMENT = 'ADD_MOVEMENT'
export const DELETE_MOVE = 'DELETE_MOVE'
export const DISPLAY_ERROR = 'DISPLAY_ERROR'
export const EXERCISE_UNMOUNT = 'EXERCISE_UNMOUNT'
export const PREVIEW_INIT = 'PREVIEW_INIT'
export const DELETE_TEMPLATE_IN_PLAN = 'DELETE_TEMPLATE_IN_PLAN'
export const CHANGE_ORDER = 'CHANGE_ORDER'
export const CREATE_PLAN_FOR_CLIENT = 'CREATE_PLAN_FOR_CLIENT'
export const COMPLETE_MESSAGE = 'COMPLETE_MESSAGE'
export const ADD_PERIOD = 'ADD_PERIOD'
export const CHANGE_PERIOD = 'CHANGE_PERIOD'
export const DELETE_PERIOD = 'DELETE_PERIOD'
export const DELETE_ALL = 'DELETE_ALL'
export const ADD_GROUP = 'ADD_GROUP'
export const CHANGE_GROUP = 'CHANGE_GROUP'
export const DELETE_GROUP = 'DELETE_GROUP'
export const RENAME_GROUP = 'RENAME_GROUP'
export const RENAME_GROUP_DONE = 'RENAME_GROUP_DONE'
export const RENAMING_GROUP = 'RENAMING_GROUP'
export const LOSE_FOCUS = 'LOSE_FOCUS'
export const SWITCH_TO = 'SWITCH_TO'
export const SHOW_NEW_VIDEO_WEB = 'SHOW_NEW_VIDEO_WEB'
export const CLOSE_NEW_VIDEO = 'CLOSE_NEW_VIDEO'
export const INTRODUCE_TEMPLATE_START = 'INTRODUCE_TEMPLATE_START'
export const INTRODUCE_TEMPLATE_SUCCESS = 'INTRODUCE_TEMPLATE_SUCCESS'
export const INTRODUCE_TEMPLATE_FAIL = 'INTRODUCE_TEMPLATE_FAIL'
export const CLOSE_TEMPLATES = 'CLOSE_TEMPLATES'
export const CLOSE_PROPOSAL = 'CLOSE_PROPOSAL'
export const CHANGE_TEMPLATE_ID = 'CHANGE_TEMPLATE_ID'
export const INTRODUCE_ONE_TEMPLATE_START = 'INTRODUCE_ONE_TEMPLATE_START'
export const INTRODUCE_ONE_TEMPLATE_SUCCESS = 'INTRODUCE_ONE_TEMPLATE_SUCCESS'
export const INTRODUCE_ONE_TEMPLATE_FAIL = 'INTRODUCE_ONE_TEMPLATE_FAIL'
export const COMPLETE_HOMEWORK = 'COMPLETE_HOMEWORK'
export const CHANGE_PERIOD_ORDER = 'CHANGE_PERIOD_ORDER'
export const SHOW_PROPOSAL_SUCCESS = 'SHOW_PROPOSAL_SUCCESS'
export const DELETE_REFERENCE = 'DELETE_REFERENCE'
export const CHANGE_REFERENCE = 'CHANGE_REFERENCE'
export const ADD_REFERENCE = 'ADD_REFERENCE'
export const CHANGE_PROPOSAL = 'CHANGE_PROPOSAL'


// Categories
export const CATEGORY_CLICK = 'CATEGORY_CLICK'
export const BACK_CLICK = 'BACK_CLICK'
export const DROP_DOWN = 'DROP_DOWN'
export const SEARCH_MOVES_START = 'SEARCH_MOVES_START'
export const SEARCH_MOVES_SUCCESS = 'SEARCH_MOVES_SUCCESS'
export const SEARCH_MOVES_FAIL = 'SEARCH_MOVES_FAIL'
export const CATEGORIES_INIT = 'CATEGORIES_INIT'
export const SEARCH_ALL_SUCCESS = 'SEARCH_ALL_SUCCESS'
export const SEARCH_ALL_START = 'SEARCH_ALL_START'
export const BC_SEARCH_CHANGE = 'BC_SEARCH_CHANGE'
export const SEARCH_CHOSEN_VIDEOS_SUCCESS = 'SEARCH_CHOSEN_VIDEOS_SUCCESS'
export const SEARCH_CHOSEN_VIDEOS_FAIL = 'SEARCH_CHOSEN_VIDEOS_FAIL'

// TempCates
export const TEMP_CATE_CLICK = 'TEMP_CATE_CLICK'
export const TEMP_BACK_CLICK = 'TEMP_BACK_CLICK'
export const TEMP_DROP_DOWN = 'TEMP_DROP_DOWN'
export const SEARCH_TEMPS_START = 'SEARCH_TEMPS_START'
export const SEARCH_TEMPS_SUCCESS = 'SEARCH_TEMPS_SUCCESS'
export const SEARCH_TEMPS_FAIL = 'SEARCH_TEMPS_FAIL'
export const TEMP_CATEGORIES_INIT = 'TEMP_CATEGORIES_INIT'

// AuthRoute
export const AUTHENTICATE = 'AUTHENTICATE'
export const LOGOUT = 'LOGOUT'
export const CHANGE_EXPAND = 'CHANGE_EXPAND'
export const CHANGE_EDU = 'CHANGE_EDU'
export const SHOW_BIND_INFO = 'SHOW_BIND_INFO'

// ClientDetail
export const FETCH_CLIENT_DETAIL_START = 'FETCH_CLIENT_DETAIL_START'
export const FETCH_CLIENT_DETAIL_SUCCESS = 'FETCH_CLIENT_DETAIL_SUCCESS'
export const FETCH_CLIENT_DETAIL_FAIL = 'FETCH_CLIENT_DETAIL_FAIL'
export const DELETE_PLAN = 'DELETE_PLAN'
export const REAL_PLAN_DELETE_START = 'REAL_PLAN_DELETE_START'
export const REAL_PLAN_DELETE_FAIL = 'REAL_PLAN_DELETE_FAIL'
export const REAL_PLAN_DELETE_SUCCESS = 'REAL_PLAN_DELETE_SUCCESS'
export const DELETE_PLAN_FINISHED = 'DELETE_PLAN_FINISHED'
export const EDIT_PLAN_START = 'EDIT_PLAN_START'
export const EDIT_PLAN_FAIL = 'EDIT_PLAN_FAIL'
export const EDIT_PLAN_SUCCESS = 'EDIT_PLAN_SUCCESS'
export const FETCH_CLIENT_DETAIL_SUCCESS_ADMIN = 'FETCH_CLIENT_DETAIL_SUCCESS_ADMIN'
export const EDIT_CLIENT_DETAIL = 'EDIT_CLIENT_DETAIL'
export const CANCEL_EDIT_CLIENT_DETAIL = 'CANCEL_EDIT_CLIENT_DETAIL'
export const CHANGE_CLIENT_DETAIL = 'CHANGE_CLIENT_DETAIL'
export const SAVE_CLIENT_DETAIL = 'SAVE_CLIENT_DETAIL'
export const SAVE_CLIENT_DETAIL_SUCCESS = 'SAVE_CLIENT_DETAIL_SUCCESS'
export const SAVE_CLIENT_DETAIL_FAIL = 'SAVE_CLIENT_DETAIL_FAIL'
export const SAVE_CLIENT_DETAIL_START = 'SAVE_CLIENT_DETAIL_START'

// Detail
export const CLOSE_DETAIL_MODAL = 'CLOSE_DETAIL_MODAL'
export const CHANGE_ALL_DAY = 'CHANGE_ALL_DAY'
export const CHANGE_EXTRA = 'CHANGE_EXTRA'
export const CHANGE_SINGLE = 'CHANGE_SINGLE'
export const CHANGE_THERAPY_SINGLE = 'CHANGE_THERAPY_SINGLE'
export const CHANGE_TO_INT = 'CHANGE_TO_INT'
export const SAVING_START = 'SAVING_START'
export const NOT_INT = 'NOT_INT'
export const NOT_BETWEEN = 'NOT_BETWEEN'
export const PRICE_NOT_VALID = 'PRICE_NOT_VALID'
export const NOT_GREATER_THAN_15 = 'NOT_GREATER_THAN_15'
export const CURRENT_PERIOD_SHORTER = 'CURRENT_PERIOD_SHORTER'
export const NOT_COMPLETE = 'NOT_COMPLETE'
export const SAVING_SUCCESS = 'SAVING_SUCCESS'
export const SAVING_FAIL = 'SAVING_FAIL'
export const SHOW_DETAIL = 'SHOW_DETAIL'
export const SET_CLIENT_NAME = 'SET_CLIENT_NAME'
export const MODAL_LOADING = 'MODAL_LOADING'
export const SHOW_PLAN_DETAIL_SUCCESS = 'SHOW_PLAN_DETAIL_SUCCESS'
export const SHOW_PLAN_DETAIL_FAIL = 'SHOW_PLAN_DETAIL_FAIL'
export const DELETE_ONE = 'DELETE_ONE'
export const DELETE_ARTICLE = 'DELETE_ARTICLE'
export const DELETE_THERAPY = 'DELETE_THERAPY'
export const ADD_PARAMETER = 'ADD_PARAMETER'
export const DELETE_THERAPY_PARAMETER = 'DELETE_THERAPY_PARAMETER'
export const CHANGE_PARAMETER_NAME = 'CHANGE_PARAMETER_NAME'
export const CHANGE_PARAMETER_VALUE = 'CHANGE_PARAMETER_VALUE'
export const NO_MOVES = 'NO_MOVES'
export const CHANGE_PRICE = 'CHANGE_PRICE'
export const SHOW_TEMPLATE_SUCCESS = 'SHOW_TEMPLATE_SUCCESS'
export const SHOW_TEMPLATE_FAIL = 'SHOW_TEMPLATE_FAIL'
export const UPDATING_START = 'UPDATING_START'
export const UPDATING_SUCCESS = 'UPDATING_SUCCESS'
export const UPDATING_FAIL = 'UPDATING_FAIL'
export const DELETE_PARAMETER = 'DELETE_PARAMETER'
export const SHOW_PLAN_MODAL = 'SHOW_PLAN_MODAL'
export const CHANGE_PERIOD_DAYS = 'CHANGE_PERIOD_DAYS'
export const SEE_FEEDBACK_SUCCESS = 'SEE_FEEDBACK_SUCCESS'

// Students
export const FETCH_CLASSES_AND_STUDENTS_START = 'FETCH_CLASSES_AND_STUDENTS_START'
export const FETCH_CLASSES_AND_STUDENTS_SUCCESS = 'FETCH_CLASSES_AND_STUDENTS_SUCCESS'
export const FETCH_CLASSES_AND_STUDENTS_FAIL = 'FETCH_CLASSES_AND_STUDENTS_FAIL'
export const TITLE_CHANGE_START = 'TITLE_CHANGE_START'
export const TITLE_CHANGE_SUCCESS = 'TITLE_CHANGE_SUCCESS'
export const TITLE_CHANGE_FAIL = 'TITLE_CHANGE_FAIL'
export const SUBMIT_NEW_TITLE_START = 'SUBMIT_NEW_TITLE_START'
export const SUBMIT_NEW_TITLE_SUCCESS = 'SUBMIT_NEW_TITLE_SUCCESS'
export const SUBMIT_NEW_TITLE_FAIL = 'SUBMIT_NEW_TITLE_FAIL'
export const SUBMIT_REVIEW_START = 'SUBMIT_REVIEW_START'
export const SUBMIT_REVIEW_SUCCESS = 'SUBMIT_REVIEW_SUCCESS'
export const SUBMIT_REVIEW_FAIL = 'SUBMIT_REVIEW_FAIL'
export const SEE_PROPOSAL_SUCCESS = 'SEE_PROPOSAL_SUCCESS'
export const SEE_PROPOSAL_FAIL = 'SEE_PROPOSAL_FAIL'
export const CLOSE_STUDENT_PROPOSAL = 'CLOSE_STUDENT_PROPOSAL'
export const MODAL_STUDENT_LOADING = 'MODAL_STUDENT_LOADING'

// Homework
export const FETCH_CLASSES_AND_HOMEWORK_START = 'FETCH_CLASSES_AND_HOMEWORK_START'
export const FETCH_CLASSES_AND_HOMEWORK_SUCCESS = 'FETCH_CLASSES_AND_HOMEWORK_SUCCESS'
export const FETCH_CLASSES_AND_HOMEWORK_FAIL = 'FETCH_CLASSES_AND_HOMEWORK_FAIL'



// Do nothing
export const DO_NOTHING = 'DO_NOTHING'





// WEBPACK FOOTER //
// ./src/store/actions/actionTypes.js